var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgPublishMirror1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 388,
    height: 841,
    viewBox: "0 0 388 841",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-BG_type1_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 388,
    height: 841
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BG_type1_5",
    "data-name": "BG_type1 \\u2013 5",
    clipPath: "url(#clip-BG_type1_5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 388,
    height: 841,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 388,
    height: 841,
    fill: "#006"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    cx: 205.5,
    cy: 205.5,
    r: 205.5,
    transform: "translate(250.308 -307)",
    fill: "#0000af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M95.168,8.056Q90.077,1.039,84.339.092T67.776,8.056q-4.45,5.091-11.785,12.1-7.315,7-15.288,15.606-7.958,8.6-16.881,18.155T6.624,73.03a22.474,22.474,0,0,0-6.371,12.1q-1.267,7,3.823,14.015L53.763,177.5q3.82,5.734,6.688,7.325c1.91,1.055,3.612,1.275,5.1.638a15.956,15.956,0,0,0,4.777-3.5,48.558,48.558,0,0,1,5.1-4.459l73.256-59.879q5.106-5.1,1.911-13.058a105.234,105.234,0,0,0-8.281-16.244q-12.094-22.306-23.569-43A352.063,352.063,0,0,0,95.168,8.056",
    transform: "translate(326.399 124)",
    fill: "#ff1335"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    cx: 225,
    cy: 225,
    r: 225,
    transform: "translate(-364.692 79)",
    fill: "#6ee7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M-9966.668-4517.5c73,12,137.5,44.5,197.5,158.5s52.166,136,113.5,276S-9437-3833.333-9309-3789.333",
    transform: "translate(9864.976 4549)",
    fill: "none",
    stroke: "#0000af",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M711.813,546.071c-73-12-149.484-70.892-179.447-171.8s-42.241-219.426-141.827-332.5S128,85.922,0,41.922",
    transform: "translate(720.772 408.109) rotate(169)",
    fill: "none",
    stroke: "#0000af",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M711.813,577.279c-73-12-149.484-70.892-179.447-171.8S519.291,148.959,419.705,35.88,128,117.13,0,73.13",
    transform: "matrix(-0.921, 0.391, -0.391, -0.921, 793, 248.037)",
    fill: "none",
    stroke: "#0000af",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M-9716-4572.667s66,67.333,129.333,70.667S-9474-4566-9454-4584.667",
    transform: "translate(9773.308 4543)",
    fill: "none",
    stroke: "#0000af",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M-9667.313-4434.667c-42,11.333-132.668-.667-149.334,36.667s17.333,121.333,124,190",
    transform: "translate(10091.288 4543)",
    fill: "none",
    stroke: "#0000af",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(65.308 142)",
    fill: "#1c1cff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_103",
    "data-name": "Ellipse 103",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(74.308 20)",
    fill: "#1c1cff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(71.308 151)",
    fill: "#fde047"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_104",
    "data-name": "Ellipse 104",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(256.308 9)",
    fill: "#fde047"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_102",
    "data-name": "Ellipse 102",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(45.308 47)",
    fill: "#6ee7b7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(59.308 133)",
    fill: "#ff1335"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(36.308 41)",
    fill: "#ff1335"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    cx: 225,
    cy: 225,
    r: 225,
    transform: "translate(76.308 486)",
    fill: "#0000af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M166.776,14.117Q157.854,1.822,147.8.162T118.774,14.117q-7.8,8.922-20.652,21.21Q85.3,47.6,71.331,62.676,57.386,77.748,41.748,94.492q-15.619,16.746-30.141,33.49A39.384,39.384,0,0,0,.443,149.191q-2.22,12.271,6.7,24.56L94.216,311.058q6.694,10.048,11.721,12.837c3.348,1.849,6.33,2.234,8.93,1.118a27.962,27.962,0,0,0,8.372-6.14,85.092,85.092,0,0,1,8.931-7.815L260.547,206.124q8.947-8.946,3.349-22.884a184.42,184.42,0,0,0-14.512-28.466q-21.193-39.09-41.3-75.353a616.972,616.972,0,0,0-41.3-65.3",
    transform: "translate(-132.718 640.063)",
    fill: "#fde047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M-9353.257-4332.333c23,50.333,42,197.667,5.334,267s-181.334,138-181.334,138",
    transform: "translate(9459.897 4543)",
    fill: "none",
    stroke: "#0000af",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M-9697-4337.5c33.75,52.5,22.75,165,77.5,211.75",
    transform: "translate(9919.808 4543)",
    fill: "none",
    stroke: "#0000af",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPublishMirror1);
export default __webpack_public_path__ + "static/media/bg_publish_mirror1.39719dfe2c1cf47b046d5dee9ba03ce0.svg";
export { ForwardRef as ReactComponent };